import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/* eslint-disable require-jsdoc */
var LAZY_LOAD_CLASS = 'spa-lazy-image';
var DEFAULT_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
var pictureDefaults = {
  viewports: ['custom', 'xxlarge', 'xlarge', 'large', 'medium', 'small'],
  mediaQueriesList: {
    small: 'only screen and (min-width:1px)',
    medium: 'only screen and (min-width:768px)',
    large: 'only screen and (min-width:1025px)',
    xlarge: 'only screen and (min-width:1440px)',
    xxlarge: 'only screen and (min-width:1921px)'
  }
};
/**
 * Class used to register helper with Handlebars.
 */
var PictureDefaultsUtility = /*#__PURE__*/function () {
  function PictureDefaultsUtility() {
    _classCallCheck(this, PictureDefaultsUtility);
  }
  return _createClass(PictureDefaultsUtility, null, [{
    key: "getPictureViewports",
    value:
    /**
     * Provides Picture Viewport Options
     * @returns {object} Picture viewports
     */
    function getPictureViewports() {
      return pictureDefaults.viewports;
    }

    /**
     * Provides Picture Mediaquery List
     * @returns {object} Picture MediaQuery List
     */
  }, {
    key: "getPictureMediaQList",
    value: function getPictureMediaQList() {
      return pictureDefaults.mediaQueriesList;
    }
  }, {
    key: "getPictureConstant",
    value: function getPictureConstant() {
      return {
        LAZY_LOAD_CLASS: LAZY_LOAD_CLASS,
        DEFAULT_PLACEHOLDER: DEFAULT_PLACEHOLDER
      };
    }
  }]);
}();
export { DEFAULT_PLACEHOLDER, LAZY_LOAD_CLASS, PictureDefaultsUtility as default };